<template>

    <div>
        <fin-notice-info></fin-notice-info>
<!--        <van-nav-bar :title="title" ></van-nav-bar>-->
        <van-tabs v-model="active" sticky swipeable>

            <van-tab v-for="item in baoRecTypes" :title="item.text" :key="item.id">
              <bao-record :rec-type="item.attrId" :rec-color="item.attrDesc" v-if="busiConsts.BAO_REC_TYPE_HOLIDAY == item.attrId"></bao-record>
              <bao-comm-record :rec-type="item.attrId" :rec-color="item.attrDesc" v-if="busiConsts.BAO_REC_TYPE_HOLIDAY != item.attrId"></bao-comm-record>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>

    import BaoRecord from "./baorecord/BaoRecord";
    import BaoCommRecord from "./baorecord/BaoCommRecord";

    import FinNoticeInfo from "./other/FinNoticeInfo";
    import * as MyApi from "@/api/URLApiAddr";
    import * as BusiConsts from '@/common/BusiConsts.js'
    import store from "@/store";
    import * as types from "@/common/types/mutation";
    export default {
        name: "FinancePage",
        components: {
            BaoRecord,
            FinNoticeInfo,
            BaoCommRecord
        },
        data(){
            return {
              busiConsts: BusiConsts,
              active:0,
              baoRecTypes:[]
            }
        },
      created:function () {
        this.$nextTick(function () {
          //console.log(this.message);
          this.initData();
        })

      },
      methods: {
          async initData(){
            let user = store.state.sys.user
            let params = {attrIds:[23,24],userId:user.userId}
            await this.$axios.post(MyApi.QRY_BAO_REC_LIST,params).then((resp) => {
              this.baoRecTypes = resp.data.baoRecType
              store.commit(types.BUSI+types.BAO_RECORDS,resp.data.baoRecords);
            }).catch((error) => {
              console.log(error)
              this.$toast.fail("类型数据初始化异常1");
            })
          },
        async initRecTypeData(type){
            debugger
          let params = {recType:type};
          await this.$axios.post(MyApi.QRY_BAO_REC_LIST,params).then((resp) => {
            params.data = resp.data
            //resp.data
            store.commit(types.BUSI+types.BAO_RECORDS,params);
          }).catch((error) => {
            this.$toast.fail("类型数据初始化异常2"+error);
          })
        }
      }
    }
</script>

<style scoped>

</style>
